<div
  mat-dialog-title
  class="modal-title"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragHandle
>
  <span class="modal-title-label">{{ getTitle() }}</span>
  <button
    class="modal-close-button"
    mat-icon-button
    matTooltip="{{ httpService.getTransation().Close }}"
    (click)="onCancel()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="pt-1">
  <div class="form-section">
    <div class="position-control">
      <mat-form-field class="position-input">
        <mat-label>{{ getPositionLabel() }}</mat-label>
        <input
          matInput
          type="text"
          inputmode="numeric"
          pattern="[0-9]*"
          [(ngModel)]="position"
          (input)="validatePositionInput($event)"
          (blur)="validatePositionOnBlur()"
          min="1"
          [max]="data.operation === 'insert' ? data.currentCount + 1 : data.currentCount"
          required
        />
        <mat-hint *ngIf="data.operation === 'insert'">Enter a number between 1 and {{ data.currentCount + 1 }}</mat-hint>
        <mat-hint *ngIf="data.operation === 'delete'">Enter a number between 1 and {{ data.currentCount }}</mat-hint>
        <mat-error *ngIf="formSubmitted && !isValid()">
          Invalid position
        </mat-error>
      </mat-form-field>
      <div class="navigation-buttons">
        <button
          mat-icon-button
          (click)="movePrevious()"
          [disabled]="position <= 1"
          [matTooltip]="data.mode === 'rows' ? 'Move Up (↑)' : 'Move Left (←)'"
        >
          <mat-icon>{{ data.mode === 'rows' ? 'arrow_upward' : 'arrow_back' }}</mat-icon>
        </button>
        <button
          mat-icon-button
          (click)="moveNext()"
          [disabled]="position >= (data.operation === 'insert' ? data.currentCount + 1 : data.currentCount)"
          [matTooltip]="data.mode === 'rows' ? 'Move Down (↓)' : 'Move Right (→)'"
        >
          <mat-icon>{{ data.mode === 'rows' ? 'arrow_downward' : 'arrow_forward' }}</mat-icon>
        </button>
      </div>
    </div>

    <mat-radio-group *ngIf="data.operation === 'insert'" [(ngModel)]="insertBefore" (ngModelChange)="onInsertBeforeChange()" class="insert-location-group">
      <mat-radio-button [value]="true" class="insert-location-option">
        {{ getInsertBeforeLabel() }}
      </mat-radio-button>
      <mat-radio-button [value]="false" class="insert-location-option">
        {{ getInsertAfterLabel() }}
      </mat-radio-button>
    </mat-radio-group>

    <mat-form-field class="full-width">
      <mat-label>{{ getCountLabel() }}</mat-label>
      <input
        matInput
        type="text"
        inputmode="numeric"
        pattern="[0-9]*"
        [(ngModel)]="count"
        (input)="validateCountInput($event)"
        (blur)="validateCountOnBlur()"
        min="1"
        [max]="data.operation === 'insert' ? 50 : data.currentCount"
        required
      />
      <mat-hint *ngIf="data.operation === 'insert'">Maximum 50</mat-hint>
      <mat-hint *ngIf="data.operation === 'delete'">Maximum {{ data.currentCount }}</mat-hint>
      <mat-error *ngIf="formSubmitted && !isValid()">
        Invalid count
      </mat-error>
    </mat-form-field>

    <div class="hint-box" style="display: block;">
      <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 8px;">
        <mat-icon class="hint-icon">info</mat-icon>
        <span class="hint-text">{{ getHintText() }}</span>
      </div>
      <div style="height: 1px; background-color: rgba(33, 150, 243, 0.2); margin: 8px 0;"></div>
      <div style="display: flex; align-items: center; gap: 8px;">
        <mat-icon class="hint-icon" style="color: #2196f3;">touch_app</mat-icon>
        <span class="hint-text">Click or tap on the grid to select a {{ data.mode === 'rows' ? 'row' : 'column' }}</span>
      </div>
    </div>
  </div>
</div>

<div mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="!isValid()">
    {{ data.operation === 'insert' ? 'Insert' : 'Remove' }} {{ count }} {{ data.mode === 'rows' ? 'Row' : 'Column' }}{{ count > 1 ? 's' : '' }}
  </button>
  <button mat-raised-button cdkFocusInitial (click)="onCancel()">
    {{ httpService.getTransation().Cancel }}
  </button>
</div>
